// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r7SU","tabsBox":"styles_tabsBox__2hSko","createButton":"styles_createButton__2456X"};